import { MicroFrontend } from '@praxis/component-microfrontend'
import apiConfig from '../../globalConfig/apiConfig'
import { LoadingProfileMfe } from '../common/LoadingProfileMfe'

export const BulkMfe = ({ ...rest }) => {
  const path = `${apiConfig.remotes.bulk}/remoteEntry.js`
  return (
    <>
      <MicroFrontend
        module="./bulk"
        src={path}
        anyProp={'any value'}
        Loading={LoadingProfileMfe}
        {...rest}
      />
    </>
  )
}
